import React from 'react';

import { useTranslation } from 'react-i18next';

export default function DragOverlay() {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'uploader.components.DragOverlay',
  });

  return (
    <div className='tw-absolute tw-inset-0 tw-z-20 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-grey-200/90'>
      <div className='tw-text-center tw-text-3xl tw-font-medium tw-text-grey-800'>
        {i18nT('description')}
      </div>
    </div>
  );
}
